import React from 'react';
import ExpansionTableRow from 'emerald-ui/lib/ExpansionTableRow';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: ExpansionTableRow, componentName: 'ExpansionTableRow' }], 'ExpansionTableRow'),
  description: (
    <span>
      A TableRow that has the capability of expanding to show additional content. Use{' '}
      <span className="code">ExpansionTableRow.Summary</span> for the the summary cells,{' '}
      <span className="code">ExpansionTableRow.AlternativeSummary</span> for the content of the summary when the row is
      expanded and <span className="code">ExpansionTableRow.Content</span> for the content that shows when the row is
      expanded.
    </span>
  ),
  codeSamples: [
    {
      title: 'Default',
      scope: { ExpansionTableRow, React },
      code: `class ExpandableRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rowExpanded: false
    };

    this.handleExpandToggle = this.handleExpandToggle.bind(this);
  }

  // You can use here an arrow function instead to avoid using binding in the constructor:
  // handleExpandToggle = () => {}
  handleExpandToggle() {
    this.setState(prevState => ({ rowExpanded: !prevState.rowExpanded }));
  }

  render() {
    return (
      <div style={{ overflow: 'auto' }}>
        <table className="eui-table">
          <ExpansionTableRow
            onToggle={this.handleExpandToggle}
            expanded={this.state.rowExpanded}
            checkboxAriaLabel="Mark Weaver"
          >
            <ExpansionTableRow.Summary>
              <td>Mark Weaver</td>
              <td>Marketing Assistant</td>
              <td>Sports</td>
            </ExpansionTableRow.Summary>
            <ExpansionTableRow.Content>
              <div>
                <h1>This is a header</h1>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
              </div>
            </ExpansionTableRow.Content>
          </ExpansionTableRow>
        </table>
      </div>
    );
  }
}`,
    },
  ],
};
